import { isString } from 'lodash';

export const ADD_FLASH_NOTIFICATION = 'ADD_FLASH_NOTIFICATION';
export const REMOVE_FLASH_NOTIFICATION = 'REMOVE_FLASH_NOTIFICATION';

const dispatchOrWrap = (actionObj, dispatch=null) => {
    // useful so you can write action creators
    // that either take dispatch directly (i.e. from useDispatch)
    // or that return functions that take dispatch (i.e. in connect())
    if (dispatch) {
        return dispatch(actionObj);
    } else {
        return dispatch => {
            dispatch(actionObj);
        };
    }
};

export function addNotification(notification, dispatch=null) {
    if (isString(notification)) {
        notification = { message: notification };
    }

    return dispatchOrWrap(
        { type: ADD_FLASH_NOTIFICATION, notification },
        dispatch,
    );
}

export function removeNotification(notificationId, dispatch=null) {
    return dispatchOrWrap(
        { type: REMOVE_FLASH_NOTIFICATION, notificationId },
        dispatch,
    );
}

const actions = {
    ADD: ADD_FLASH_NOTIFICATION,
    addNotification,
    REMOVE: REMOVE_FLASH_NOTIFICATION,
    removeNotification,
};

export default actions;
